module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-wrapper"
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.children.length === 0) ? _c('el-menu-item', {
      key: item.label,
      attrs: {
        "index": _vm.filterPath(item.path, index)
      },
      on: {
        "click": function($event) {
          return _vm.open(item)
        }
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.label))])]) : _c('el-submenu', {
      key: item.label,
      attrs: {
        "index": _vm.filterPath(item.label, index)
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), (item.parentId === -1) ? _c('span', {
      class: {
        'el-menu--display': _vm.isCollapse
      },
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.label))]) : _c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _vm._l((item.children), function(child, cindex) {
      return [(child.children.length == 0) ? _c('el-menu-item', {
        key: cindex,
        attrs: {
          "index": _vm.filterPath(child.path, cindex)
        },
        on: {
          "click": function($event) {
            return _vm.open(child)
          }
        }
      }, [_c('i', {
        class: child.icon
      }), _vm._v(" "), _c('span', {
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [_vm._v(_vm._s(child.label))])]) : _c('sidebar-item', {
        key: cindex,
        attrs: {
          "menu": [child],
          "isCollapse": _vm.isCollapse
        }
      })]
    })], 2)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5efef8e9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/page/index/sidebar/sidebarItem.vue
// module id = zctc
// module chunks = 5